import { render, staticRenderFns } from "./CompletionCard.vue?vue&type=template&id=3a02e70b"
import script from "./CompletionCard.vue?vue&type=script&lang=js"
export * from "./CompletionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports